var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 120,
    viewBox: "0 0 162 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0078 60C14.0078 26.8629 40.8873 0 74.0449 0V0V120V120C40.8873 120 14.0078 93.1371 14.0078 60V60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 120V0C73.3311 0 72.6648 0.0109447 72.0012 0.0326649C39.7894 1.08701 14 27.5318 14 60C14 92.4682 39.7894 118.913 72.0012 119.967C72.6648 119.989 73.3311 120 74 120ZM72.0012 117.966V2.03379C40.8925 3.08723 15.9988 28.6375 15.9988 60C15.9988 91.3624 40.8925 116.913 72.0012 117.966Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-17 76.6364L-9.31061 52.8419V13H62.3106V52.8419L70 75.0455H45.504C44.377 75.0455 43.4635 75.959 43.4635 77.086V77.086C43.4635 78.2129 44.377 79.1265 45.504 79.1265H70V83H-17V79.1265H9.14394V76.6364H-17ZM58.7435 16.9773L-6.23498 16.8043V51.8801H58.8987L58.7435 16.9773Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 39H51L46.625 51H41.375L37 39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 60C144 93.1371 117.137 120 84 120V120L84 5.24213e-06V5.24213e-06C117.137 2.34698e-06 144 26.8629 144 60V60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 5.24213e-06L84 120C84.6693 120 85.336 119.989 86 119.967C118.211 118.912 144 92.4678 144 60C144 27.5322 118.211 1.08769 86 0.0327123C85.336 0.0109686 84.6693 5.18365e-06 84 5.24213e-06ZM86 2.03384L86 117.966C117.106 116.912 142 91.3631 142 60C142 28.6369 117.106 3.08792 86 2.03384Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 55C31 61.6274 25.6274 67 19 67C12.3726 67 7 61.6274 7 55C7 48.3726 12.3726 43 19 43C25.6274 43 31 48.3726 31 55Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 65C24.5228 65 29 60.5228 29 55C29 49.4772 24.5228 45 19 45C13.4772 45 9 49.4772 9 55C9 60.5228 13.4772 65 19 65ZM19 67C25.6274 67 31 61.6274 31 55C31 48.3726 25.6274 43 19 43C12.3726 43 7 48.3726 7 55C7 61.6274 12.3726 67 19 67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 86.128C3 77.2208 10.1634 70 19 70C27.8366 70 35 77.2208 35 86.128V90C35 92.2091 33.2091 94 31 94H7C4.79086 94 3 92.2091 3 90V86.128Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 90V86.128C33 78.3103 26.717 72 19 72C11.283 72 5 78.3103 5 86.128V90C5 91.1046 5.89543 92 7 92H31C32.1046 92 33 91.1046 33 90ZM19 70C10.1634 70 3 77.2208 3 86.128V90C3 92.2091 4.79086 94 7 94H31C33.2091 94 35 92.2091 35 90V86.128C35 77.2208 27.8366 70 19 70Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.589 79C101.589 84.5228 96.9459 89 91.2183 89C85.4908 89 80.8477 84.5228 80.8477 79C80.8477 73.4772 85.4908 69 91.2183 69C96.9459 69 101.589 73.4772 101.589 79Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 102.752C79 96.8138 84.3726 92 91 92C97.6274 92 103 96.8138 103 102.752V104C103 106.209 101.209 108 99 108H83C80.7909 108 79 106.209 79 104V102.752Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.589 90C129.589 95.5228 124.946 100 119.218 100C113.491 100 108.848 95.5228 108.848 90C108.848 84.4772 113.491 80 119.218 80C124.946 80 129.589 84.4772 129.589 90Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 113.752C107 107.814 112.373 103 119 103C125.627 103 131 107.814 131 113.752V115C131 117.209 129.209 119 127 119H111C108.791 119 107 117.209 107 115V113.752Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.589 79C157.589 84.5228 152.946 89 147.218 89C141.491 89 136.848 84.5228 136.848 79C136.848 73.4772 141.491 69 147.218 69C152.946 69 157.589 73.4772 157.589 79Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 102.752C135 96.8138 140.373 92 147 92C153.627 92 159 96.8138 159 102.752V104C159 106.209 157.209 108 155 108H139C136.791 108 135 106.209 135 104V102.752Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.071 26C118.071 29.866 114.935 33 111.067 33C107.198 33 104.062 29.866 104.062 26C104.062 22.134 107.198 19 111.067 19C114.935 19 118.071 22.134 118.071 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 22.5C48 24.9853 45.9853 27 43.5 27C41.0147 27 39 24.9853 39 22.5C39 20.0147 41.0147 18 43.5 18C45.9853 18 48 20.0147 48 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.062 41.8C103.062 37.4922 106.644 34 111.062 34C115.481 34 119.062 37.4922 119.062 41.8V44C119.062 45.1046 118.167 46 117.062 46H105.062C103.958 46 103.062 45.1046 103.062 44V41.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 33.2C38 30.3281 40.4624 28 43.5 28C46.5376 28 49 30.3281 49 33.2V35C49 35.5523 48.5523 36 48 36H39C38.4477 36 38 35.5523 38 35V33.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 49C98 48.4477 98.4477 48 99 48H123C123.552 48 124 48.4477 124 49V49C124 49.5523 123.552 50 123 50H99C98.4477 50 98 49.5523 98 49V49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 37.5C36 37.2239 36.2239 37 36.5 37H51.5C51.7761 37 52 37.2239 52 37.5V37.5C52 37.7761 51.7761 38 51.5 38H36.5C36.2239 38 36 37.7761 36 37.5V37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.062 52H121.075L114.821 72H107.316L101.062 52Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNoteIcon);
export default __webpack_public_path__ + "static/media/event-note-icon.9123c3e9.svg";
export { ForwardRef as ReactComponent };